import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import styles from "./login.module.scss";
import classNames from "classnames";
import * as Yup from "yup";
import { useFormik } from "formik";
import { handlePostRequest } from "../../services/PostTemplate";
import { AuthSlice } from "../../redux/authSlice";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function Login() {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
    const dispatch = useDispatch();

    let history = useHistory();

    // Carousel data for logistics business
    const slides = [
        {
            id: 1,
            title: "Airport Operations",
            subtitle: "YOUR EXPRESS AIR EXPERTS",
            description: "Located at Fort Lauderdale Airport, we're set up for speed. Why store your packages in a warehouse when we can forward them immediately?",
            image: "https://res.cloudinary.com/dwxqg9so3/image/upload/v1758229560/araflane-with-cargo-tarmac-sunset-generative-ai-scaled_gkrgoj.jpg"
        },
        {
            id: 2,
            title: "48-Hour Delivery",
            subtitle: "US TO JA IN RECORD TIME",
            description: "Shop online using our Florida address. We receive, inspect, and process your packages, then we put them on the next flight to Jamaica. Simple, fast.",
            image: "https://res.cloudinary.com/dwxqg9so3/image/upload/v1758229572/freepik__aerial-view-of-fort-lauderdale-international-airpo__93335_b2ndqm.png"
        },
        {
            id: 3,
            title: "Sign Up Now",
            subtitle: "READY TO MOVE FORWARD?",
            description: "Get your US shipping address once you sign up and experience the difference airport-based operations make.",
            subdescription: "Contact Us! 954-408-2025 | help@wemove4wd.com",
            image: "https://res.cloudinary.com/dwxqg9so3/image/upload/v1758246573/laptop_kusm5m.jpg"
        }
    ];

    // Auto-slide functionality with animation control
    useEffect(() => {
        const interval = setInterval(() => {
            setIsAnimating(true);
            setTimeout(() => {
                setCurrentSlide(prev => (prev + 1) % slides.length);
                setIsAnimating(false);
            }, 200); // Short delay for exit animation
        }, 5000);

        return () => clearInterval(interval);
    }, [slides.length]);

    // Reset animation state when slide changes
    useEffect(() => {
        if (!isAnimating) {
            // Trigger enter animation
            setTimeout(() => {
                setIsAnimating(false);
            }, 100);
        }
    }, [currentSlide]);

    const validationSchema = Yup.object().shape({
        email: Yup.string().required("This field is required."),
        password: Yup.string().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            email: "",
            password: "",
        },
        onSubmit: async (data) => {
            const res = await dispatch(handlePostRequest(data, "/signin", true, true));
            const userData = res?.data;
            if (res?.data?.user) {
                localStorage.setItem("Zaziolog", "log");
                history.push("/");
                window.location.reload();
                dispatch(AuthSlice(userData));
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className={styles.loginBody}>
            <div className={styles.loginMainContainer}>
                {/* Left Section - Carousel */}
                <div className={styles.carouselSection}>
                    <div className={styles.carouselContainer}>
                        {slides.map((slide, index) => (
                            <div 
                                key={slide.id} 
                                className={`${styles.carouselSlide} ${index === currentSlide ? styles.active : ''}`}
                                style={{ backgroundImage: `url(${slide.image})` }}
                            >
                                <div className={styles.carouselOverlay}></div>
                                <div className={styles.carouselContent}>
                                    <div className={`${styles.glassCard} ${index === currentSlide ? styles.animate : ''}`}>
                                        <h3 className={`${styles.carouselSubtitle} ${index === currentSlide ? styles.animateSubtitle : ''}`}>
                                            {slide.subtitle}
                                        </h3>
                                        <h2 className={`${styles.carouselTitle} ${index === currentSlide ? styles.animateTitle : ''}`}>
                                            {slide.title}
                                        </h2>
                                        <p className={`${styles.carouselDescription} ${index === currentSlide ? styles.animateDescription : ''}`}>
                                            {slide.description}
                                        </p>
                                        {/* Subdescription - only renders if it exists */}
                                        {slide.subdescription && (
                                            <p className={`${styles.carouselSubDescription} ${index === currentSlide ? styles.animateSubDescription : ''}`}>
                                                {slide.subdescription}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right Section - Original Login Form */}
                <div className={styles.loginSection}>
                    <div className={styles.loginContainer}>
                        <div align="center" style={{ marginTop: "0%", marginBottom: "0%" }}>
                            <img src="https://res.cloudinary.com/dwxqg9so3/image/upload/v1758210476/4wd_logo_big_croped_djegsi.jpg" style={{ objectFit: "cover", height: "80px", width: "auto", marginTop: "20px" }}></img>
                        </div>
                        <div className={styles.loginForms}>
                            <p className={styles.loginHeader}>Let's get your world moving! Sign in to your Move4wd Hub</p>
                            <p className={styles.loginSubHeader}>Your personalized portal for tracking, managing, and moving forward with every shipment.</p>
                            <form action="#" className={styles.formDiv} onSubmit={formik.handleSubmit}>
                                <div className="p-mt-4">
                                    <input id="email" className={classNames({ "p-invalid": isFormFieldValid("email") }, styles.loginInput)} name="email" value={formik.values.email} placeholder="Email Address" onChange={formik.handleChange} type="text" />
                                    {getFormErrorMessage("email")}

                                    <input className={classNames({ "p-invalid": isFormFieldValid("password") }, styles.loginInput)} name="password" placeholder="Password" value={formik.values.password} onChange={formik.handleChange} type="password" />
                                    {getFormErrorMessage("password")}

                                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <p style={{ marginTop: "2px", fontSize: "12px" }}>
                                            <Link to="/reset" style={{ color: "white" }}>Forgot your way forward? Reset Password</Link>
                                        </p>
                                    </div>

                                    <div className="p-mt-2" style={{display:'flex',justifyContent:'center',marginTop:'20px'}}>
                                        <Button className={styles.loginButton} label="Sign In" icon={loadingIcon || ""} iconPos="right" disabled={loading} />
                                    </div>
                                </div>

                                <div className={styles.mobileOnly}>
                                    <p style={{ marginTop: "15px",color:"white" }}>
                                        New to Move4wd? Let's Get You Moving! <Link to="/signup">Sign Up Here</Link>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer with Privacy and Terms links */}
            <footer className={styles.footer}>
                <div className={styles.footerContent}>
                    <div className={styles.footerLeft}>
                        <p>© {new Date().getFullYear()} Move4wd. All rights reserved.</p>
                    </div>
                    <div className={styles.footerCenter}>
                        <p>Moving your world, forward.</p>
                    </div>
                    <div className={styles.footerRight}>
                        <div className={styles.footerLinks}>
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            <Link to="/termsAndCondition">Terms &amp; Conditions</Link>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Login;